import './management-page.scss';

export class ManagementPage {
  constructor(selector = '.management-wrapper__container') {
    this.sections = document.querySelectorAll(selector);
    this.breakpoint = 992; // bootstrap lg
    this.toggles = [];

    this.init();
  }

  init() {
    if (!this.sections.length) return;

    this.sections.forEach((section) => {
      const toggle = section.querySelector('.management-wrapper__toggle');
      if (!toggle) return;

      this.toggles.push({ section, toggle });

      // stato iniziale aria
      toggle.setAttribute('aria-expanded', 'true');

      toggle.addEventListener('click', () => {
        if (window.innerWidth >= this.breakpoint) return;

        section.classList.toggle('is-close');

        const expanded = !section.classList.contains('is-close');
        toggle.setAttribute('aria-expanded', expanded);
      });
    });

    // setup iniziale accessibilità
    this.updateAccessibility();

    // UN SOLO resize listener
    window.addEventListener('resize', () => {
      this.updateAccessibility();
    });
  }

  updateAccessibility() {
    const isMobile = window.innerWidth < this.breakpoint;

    this.toggles.forEach(({ section, toggle }) => {
      if (isMobile) {
        toggle.setAttribute('tabindex', '0');
      } else {
        toggle.setAttribute('tabindex', '-1');
        toggle.setAttribute('aria-expanded', 'true');
        section.classList.remove('is-close');
      }
    });
  }
}
